// Constantes compartidas del landing
export const LOGO_COLOR =
    "https://customer-assets.emergentagent.com/job_04354752-4f21-40de-8861-ebee9a564cf0/artifacts/jp27mb1f_IMG_0353.svg";

export const LOGO_WHITE =
    "https://customer-assets.emergentagent.com/job_04354752-4f21-40de-8861-ebee9a564cf0/artifacts/65g1u9cg_blanco.svg";

export const CTA_HREF = "https://silven.tuloteriadefalcon.com";
export const LOGIN_HREF = "https://silven.tuloteriadefalcon.com";

export const HERO_BG_IMAGE =
    "https://images.unsplash.com/photo-1473580044384-7ba9967e16a0?auto=format&fit=crop&w=2400&q=75";

export const LIFESTYLE_IMAGE =
    "https://customer-assets.emergentagent.com/job_c51d49c2-624f-4fd8-a804-37a913f12ec8/artifacts/n9c52wr6_foto%20nino%20landing%20falcon.png";

export const FARO_IMAGE =
    "https://upload.wikimedia.org/wikipedia/commons/thumb/2/27/Faro_del_Cabo_San_Rom%C3%A1n_en_2023.jpg/1920px-Faro_del_Cabo_San_Rom%C3%A1n_en_2023.jpg";
